import {ComponentData} from "../../engine/tools/EntityManager";
import {Vector2} from "../../engine/utils/Vector2";

export class Rotation implements ComponentData {
    value: number

    constructor(a = 0) {
        this.value = a
    }
}
export class Scale implements ComponentData {
    value: Vector2

    constructor(x = 1,y=1) {
        this.value = new Vector2(x,y)
    }
}